import { _ as _assign, b as __awaiter, c as __generator } from './tslib.es6-604585c1.js';
import fetcher from './fetcher/index.js';
import { CURRENT_LANGUAGE_COOKIE_NAME, SOCIAL_REQUEST_HEADER_TOKEN, LANGUAGE_HEADER_KEY, API_URL } from './configs/constants/index.js';
import getDeviceId from './getDeviceId/index.js';
import { getCookie } from './cookie/index.js';

var UserField;
(function (UserField) {
  UserField["name"] = "name";
  UserField["email"] = "email";
})(UserField || (UserField = {}));
var UserField$1 = UserField;

var getHeaders = function getHeaders() {
  var _a;
  var deviceId = getDeviceId();
  var language = getCookie(CURRENT_LANGUAGE_COOKIE_NAME);
  return _assign(_assign({
    platform: 'website',
    'g-recaptcha-token': '',
    'g-recaptcha-action': '',
    'Content-Type': 'application/json',
    token: SOCIAL_REQUEST_HEADER_TOKEN
  }, deviceId && {
    deviceId: deviceId
  }), language && (_a = {}, _a[LANGUAGE_HEADER_KEY] = language, _a));
};
var socialHeaders = _assign({
  'Content-Type': 'application/json',
  'token-type': 'JWT',
  platform: 'website'
}, getDeviceId() && {
  deviceid: getDeviceId()
});

var checkUsername = function checkUsername(username) {
  return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
      return [2, fetcher("".concat(API_URL, "/users/revise/username.json"), {
        method: 'POST',
        body: JSON.stringify({
          username: username
        }),
        headers: getHeaders()
      })];
    });
  });
};
var suggestUsername = function suggestUsername(ssoInfo) {
  return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
      return [2, fetcher("".concat(API_URL, "/users/usernames/suggest.json?").concat(ssoInfo.userField, "=").concat(ssoInfo.data), {
        method: 'GET',
        headers: getHeaders()
      })];
    });
  });
};

var UsernameSuggestion = function () {
  function UsernameSuggestion() {
    var _this = this;
    this.usernameSuggestionInfo = {
      data: '',
      userField: UserField$1.email
    };
    this.index = 0;
    this.suggestedUsernames = [];
    this.setUserData = function (data, userField) {
      _this.usernameSuggestionInfo.data = data;
      _this.usernameSuggestionInfo.userField = userField;
    };
    this.suggest = function () {
      return __awaiter(_this, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              if (!(!this.suggestedUsernames.length || this.index === this.suggestedUsernames.length)) return [3, 2];
              return [4, suggestUsername(this.usernameSuggestionInfo)];
            case 1:
              response = _a.sent().response;
              this.setSuggestedUsernames(response);
              this.index = 0;
              _a.label = 2;
            case 2:
              return [2, this.suggestedUsernames[this.index++]];
          }
        });
      });
    };
    this.setSuggestedUsernames = function (usernames) {
      _this.suggestedUsernames = usernames;
    };
    this.getUsernameSuggestionInfo = function () {
      return _this.usernameSuggestionInfo;
    };
    this.getSuggestedUsernames = function () {
      return _this.suggestedUsernames;
    };
  }
  return UsernameSuggestion;
}();
var usernameSuggestion = new UsernameSuggestion();

export { UserField$1 as U, UserField as a, checkUsername as c, getHeaders as g, socialHeaders as s, usernameSuggestion as u };
//# sourceMappingURL=usernameSuggestion-9f27552b.js.map
